import ArtifactGroupType from "../base/ArtifactGroupType";


const RavenHelm = {
  id: '119',
  name: 'Raven Helm',
  groupIcon: 'EchoesOfTheNorth',
  type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
  icon: 'RavenHelm',
  power: 25,
  gameId: 'HornedFury'
};

export default RavenHelm;
